<hyperkit-dialog class="hyperkit-component" headerText="New Hunt Template">
  <div class="container-fluid" id="new-hunt-template-dialog">
    <div class="row">
      <div class="container">
        <hyperkit-typography variant="body" size="md" align="left" color="body">
          Group hunt packages for repeatable hunts.</hyperkit-typography
        >
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        <form
          class="k-form"
          [formGroup]="formGroup"
          autocomplete="off"
          (ngSubmit)="onSubmit()"
        >
          <hyperkit-input
            class="hyperkit-component"
            type="text"
            id="name"
            label="Name"
            maxlength="50"
            formControlName="name"
          >
          </hyperkit-input>
          <hyperkit-multiselect
            label="Environments"
            [options]="environments"
            displayProperty="name"
            formControlName="environments"
            valueProperty="id"
            (selectionChange)="onValueChange()"
          >
          </hyperkit-multiselect>
          <hyperkit-select
            label="Priority"
            [options]="priorities"
            formControlName="priority"
          ></hyperkit-select>
          <hyperkit-select
            label="Default Assignee"
            [displayProperty]="'fullName'"
            [valueProperty]="'id'"
            [options]="assignees$ | async"
            formControlName="defaultAssignee"
          ></hyperkit-select>
          <hyperkit-textarea
            label="Abstract"
            [maxlength]="2000"
            placeholder="Include a short description of the hunt's purpose and background."
            formControlName="description"
          >
          </hyperkit-textarea>
          <hyperkit-textarea
            label="Hypothesis"
            [maxlength]="5000"
            placeholder="Provide a proposed explanation to be used as a starting point for further investigation."
            formControlName="hypothesis"
          >
          </hyperkit-textarea>
          <hyperkit-button
            size="small"
            color="tertiary"
            text="Save"
            type="submit"
            [disabled]="!formGroup.valid"
          ></hyperkit-button>
        </form>
      </div>
    </div>
  </div>
</hyperkit-dialog>
